import React, { Suspense, useEffect } from 'react';

import { PaymentElement, useStripe } from '@stripe/react-stripe-js';
import { StripePaymentElementOptions } from '@stripe/stripe-js';

import LoadingSkelaton from 'ui/LoadingSkelaton';

const StripeCheckoutForm = () => {
  const stripe = useStripe();

  useEffect(() => {
    if (!stripe) {
      return;
    }
  }, [stripe]);

  const paymentElementOptions = {
    fields: {
      billingDetails: {
        email: 'never',
      },
    },
  } as StripePaymentElementOptions;

  return (
    <Suspense fallback={<LoadingSkelaton />}>
      <PaymentElement options={paymentElementOptions} />
    </Suspense>
  );
};

export default StripeCheckoutForm;
